import {ExpressionPath, Plugins} from '@packages/systems/wfdl';
import {typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {TTypeConstructor} from '@packages/systems/wfdl-ast';

export const AUTO_PLAY_PATH: ExpressionPath = [{in: 'Record', at: 'autoPlay'}];
export const ALIGNMENT_PATH: ExpressionPath = [{in: 'Record', at: 'alignment'}];
export const FIT_PATH: ExpressionPath = [{in: 'Record', at: 'fit'}];
export const AUTOMATICALLY_HANDLE_EVENTS_PATH: ExpressionPath = [
  {in: 'Record', at: 'automaticallyHandleEvents'},
];
export const IS_TOUCH_SCROLL_ENABLED_PATH: ExpressionPath = [
  {in: 'Record', at: 'isTouchScrollEnabled'},
];
export const STATE_MACHINE_PATH: ExpressionPath = [
  {in: 'Record', at: 'stateMachine'},
];

export const ANIMATION_PLUGIN = Plugins.name('Animation');

export const PATH_NAME = qualify(ANIMATION_PLUGIN, typeName('RivePath'));
export const ARTBOARD_NAME = qualify(
  ANIMATION_PLUGIN,
  typeName('RiveArtboard')
);
export const STATE_MACHINE_NAME = qualify(
  ANIMATION_PLUGIN,
  typeName('RiveStateMachine')
);
export const AUTO_PLAY_NAME = qualify(
  ANIMATION_PLUGIN,
  typeName('RiveAutoPlay')
);
export const IS_TOUCH_SCROLL_ENABLED_NAME = qualify(
  ANIMATION_PLUGIN,
  typeName('RiveIsTouchScrollEnabled')
);
export const AUTOMATICALLY_HANDLE_EVENTS_NAME = qualify(
  ANIMATION_PLUGIN,
  typeName('RiveAutomaticallyHandleEvents')
);
export const FIT_NAME = qualify(ANIMATION_PLUGIN, typeName('RiveFit'));
export const ALIGNMENT_NAME = qualify(
  ANIMATION_PLUGIN,
  typeName('RiveAlignment')
);

export const PATH_TYPE = TTypeConstructor(PATH_NAME);
export const ARTBOARD_TYPE = TTypeConstructor(ARTBOARD_NAME);
export const STATE_MACHINE_TYPE = TTypeConstructor(STATE_MACHINE_NAME);
export const AUTO_PLAY_TYPE = TTypeConstructor(AUTO_PLAY_NAME);
export const IS_TOUCH_SCROLL_ENABLED_TYPE = TTypeConstructor(
  IS_TOUCH_SCROLL_ENABLED_NAME
);
export const AUTOMATICALLY_HANDLE_EVENTS_TYPE = TTypeConstructor(
  AUTOMATICALLY_HANDLE_EVENTS_NAME
);
export const FIT_TYPE = TTypeConstructor(FIT_NAME);
export const ALIGNMENT_TYPE = TTypeConstructor(ALIGNMENT_NAME);
